<template>
  <form>
    <div class="input-area">
      <BonusValidate :bonusData="bonusData" v-model="synBonusNum" :bonusDescription="bonusDescription"/>

      <div class="enjoy single-input">
        <div class="d-flex input-head">
          <p class="input-name">即享券</p>
        </div>
        <div class="">
          <input
            v-model="synEnjoyNum"
            name="enjoy"
            v-validate="NoChineseRule"
            type="text"
            placeholder="請輸入即享券序號"
            class="discount-text-input"
            :class="{ 'wrong-border': errors.has('enjoy') }"
          />
          <span class="red-text">{{ errors.first('enjoy') }}</span>
        </div>
      </div>

      <div class="enjoy single-input">
        <div class="d-flex input-head">
          <p class="input-name">折價券</p>
          <div
              class="switch"
              @click="toggleSwitch"
              :class="{ on: isSwitchOn }"
            > 
              <p class="status-text digital">紙本</p>
              <p class="status-text paper">電子</p>
              <div class="btn"></div>
            </div>
          <a class="btn hoverFill btn-secondary search-btn" @click="couponList">
            可用電子券查詢
          </a>
        </div>
        <div class="">
          <input
            v-model="ticketNo"
            :disabled="isSwitchOn"
            v-validate="NoChineseRule"
            type="text"
            placeholder="請輸入紙本券序號"
            name="discount"
            class="discount-text-input"
            :class="{ 'wrong-border': errors.has('discount') }"
          />
          <span class="red-text">{{ errors.first('discount') }}</span>
          <br />
          <span class="red-text">註. 紙本與電子擇一使用，請滑動開關切換抵用方式</span>
        </div>
      </div>
    </div>

    <div slot="modal-footer" class="modal_footer">
      <div class="text-center">
        <b-btn class="hoverFill" @click="handleHide">
          取消
        </b-btn>
        <a class="btn hoverFill btn-secondary" @click="submit">
          確認
        </a>
      </div>
    </div>
  </form>
</template>

<script>
import BonusValidate from '@/components/Validate/BonusValidate';
import moment from 'moment';
import discountApi from '@/api/discount';
import { mapMutations, mapGetters } from 'vuex';
import _ from 'lodash';
export default {
  components: {
    BonusValidate
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    bonusData: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    enjoyNumModal: {
      type: String,
      required: false
    },
    bonusNumModal: {
      default: null,
      required: false
    },
    bonusDescription: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      enjoyNum: '',
      discountNum: '',
      bonusNum: null,
      disCoupons: [],
      bonusDis: '',
      enjoyDis: '',
      couponDis: '',
      enJoyRes: '',
      ticketNo: '',
      EventMastId: '',
      EventDetlId: '',
      DESCRITPION: '',
      BonusPoints: '',
      DiscTypePoint: '',
      DscSku: '',
      SkuNoPoint: '',
      DiscAmnt30: '',
      SkuNo30: '',
      ReturnSkuNo30: '',
      DiscType30: '',
      Grno30: '',
      rebateName30: '',
      accountType: '',
      accountNo: '',
      copu_type: '',
      SkuNo10: '',
      ReturnSkuNo10: '',
      DiscType10: '',
      Grno10: '',
      rebateName10: '',
      RbonusPoints: ''
    };
  },
  computed: {
    ...mapGetters('cart', ['products']),
    NoChineseRule() {
      return { regex: /^[A-Za-z0-9]+$/ };
    },
    parseBonusDis() {
      return parseInt(this.bonusDis) || 0;
    },
    parseCouponDis() {
      return parseInt(this.couponDis) || 0;
    },
    parseEnjoyDis() {
      return parseInt(this.enjoyDis) || 0;
    },

    //折價券暫存資料
    couponInfoTemp() {
      return this.products[this.index].couponInfoTemp;
    },

    tempSkuno() {
      return _.get(this.couponInfoTemp, 'Skuno', '');
    },
    tempReturnSkuno() {
      return _.get(this.couponInfoTemp, 'ReturnSkuno', '');
    },
    tempDiscType() {
      return _.get(this.couponInfoTemp, 'DiscType', '');
    },
    tempGrno() {
      return _.get(this.couponInfoTemp, 'Grno', '');
    },
    tempRebateName() {
      return _.get(this.couponInfoTemp, 'RebateName', '');
    },

    // 從vuex來的折價券折抵金額
    couponDisInVuex() {
      return this.products[this.index].couponDis;
    },

    // 從vuex來的折價券序號
    ticketNoFromVuex() {
      return this.products[this.index].ticketNo;
    },

    // 從vuex來的紅利點數
    bonusNumFromVuex() {
      return this.products[this.index].bonusDefaultNum;
    },

    // 從vuex來的即享券序號
    enjoyNumFromVuex() {
      return this.products[this.index].enjoyDefaultNum;
    },

    isSwitchOn() {
      return this.products[this.index].isSwitchOn;
    },

    couponDisTemp() {
      return this.products[this.index].couponDisTemp;
    },

    ticketNoTemp() {
      return this.products[this.index].ticketNoTemp;
    },

    //即享券序號
    synEnjoyNum: {
      get() {
        return this.enjoyNumModal;
      },
      set(val) {
        this.$emit('update:enjoyNumModal', val);
      }
    },

    //折價券序號
    synticketNo: {
      get() {
        return this.ticketNo;
      },
      set(val) {
        this.$emit('update:ticketNo', val);
      }
    },

    // 紅利點數序號
    synBonusNum: {
      get() {
        return this.bonusNumModal;
      },
      set(val) {
        this.$emit('update:bonusNumModal', val);
      }
    }
  },

  created() {
    let regexMsg = {
      regex: function() {
        return '只可輸入數字與英文';
      }
    };
    const dict = {
      custom: {
        enjoy: regexMsg,
        discount: regexMsg
      }
    };
    this.$validator.localize('zh_TW', dict);

    if (this.couponDisTemp) {
      this.couponDis = this.couponDisTemp;
      this.ticketNo = this.ticketNoTemp;
    } else {
      // 一進來先從vuex拿到折價券折抵金額
      this.couponDis = this.couponDisInVuex;
      if (this.couponDisInVuex !== 0 || this.couponDisInVuex !== '') {
        // 要是折抵金額不為0,從vuex拿到折價券序號
        this.ticketNo = this.ticketNoFromVuex;
      }
    }
  },

  methods: {
    ...mapMutations('cart', ['setCartProductsDiscount']),

    // setDefaultEnjoy(){
    //    this.$emit('update:enjoyNumModal', val);
    // },

    toggleSwitch() {
      this.setCartProductsDiscount({
        index: this.index,
        isSwitchOn: '',
        couponInfoTemp: {}
      });
      this.ticketNo = '';
    },
    handleHide() {
      this.$emit('handleHide');
    },

    //紅利點數驗證失敗,重設紅利點數
    resetbonusNum(val) {
      this.$emit('update:bonusNumModal', val);
    },

    // 即享券驗證失敗,重設即享券
    resetEnjoyNum(val) {
      this.$emit('update:enjoyNumModal', val);
    },

    //折價券驗證失敗,重設折價券
    resetTicketNum(val) {
      this.ticketNo = val;
    },

    //即享券沒有值,折價券有值的狀況
    ticketNumHasValue() {
      //手動輸入折價券9碼
      if (!this.isSwitchOn) {
        if (this.ticketNo.length == 9) {
          this.callqueryCrmcoupByHand(this.calculate);
        } else {
          alert('折價券號碼錯誤');
          this.couponDis = this.couponDisInVuex;
          this.resetTicketNum(this.ticketNoFromVuex);
        }
      } else {
        // 這邊是用選取的折價券
        this.calculate();
      }
    },

    //即享券有值,折價券有值的狀況
    ticketNumHasValueEnjoy(callback) {
      //手動輸入折價券9碼
      if (!this.isSwitchOn) {
        if (this.ticketNo.length == 9) {
          this.callqueryCrmcoupByHand(this.calculateNoPayAndMinus, callback);
        } else {
          alert('折價券號碼錯誤');
          this.couponDis = this.couponDisInVuex;
          this.resetTicketNum(this.ticketNoFromVuex);
        }
      } else {
        // 這邊是用選取的折價券
        this.calculateNoPayAndMinus(callback);
      }
    },

    //可用抵用券查詢 按鈕按下去
    couponList() {
      if (this.isSwitchOn) {
        discountApi.couponList(
          {
            companyId: 'A0',
            channelId: this.product.id.slice(0, 1) + '0',
            storeId: this.product.BranchRoomID.slice(0, 4)
          },
          res => {
            if (res.length > 0) {
              this.$emit('handleHide');
              this.setCartProductsDiscount({
                index: this.index,
                disCoupons: res
              });
              this.$bvModal.show('can_use_coupon_modal' + this.index);
            } else {
              alert('無可使用之電子券');
            }
          }
        );
      }
      if (!this.isSwitchOn) {
        alert('紙本與電子擇一使用,請滑動開關切換抵用方式');
      }
    },

    //紅利點數資格查詢
    callQueryRedeemHola(callBack) {
      if (this.synBonusNum < 0) {
        alert('未達可折抵點數');
      } else {
        discountApi.queryRedeemHola(
          {
            CompanyID: 'A0',
            BranchId: this.product.BranchRoomID.slice(0, 4),
            bonusPoints: this.synBonusNum
          },
          res => {
            this.bonusDis = res.payoff;
            this.EventMastId = res.event_mast_id;
            this.EventDetlId = res.event_detl_id;
            this.DESCRITPION = res.DESCRITPION;
            this.DiscTypePoint = res.disc_type;
            this.DscSku = res.dsc_sku;
            this.SkuNoPoint = res.dsc_sku;
            this.RbonusPoints = res.RbonusPoints;
            //即享券有值
            if (this.synEnjoyNum) {
              callBack();
            } else {
              //這邊是即享券無值
              //  折價券有值
              if (this.ticketNo) {
                this.ticketNumHasValue();
              } else {
                //這邊是折價券無值
                this.couponDis = '';
                this.calculate();
              }
            }
          },
          err => {
            alert(err);
            // alert('紅利點數餘額不足');
            this.resetbonusNum(this.bonusNumFromVuex);
            return;
          }
        );
      }
    },

    //出現餘額型折價券
    showBalanceModal() {
      this.handleHide();
      this.$bvModal.show('balance_enjoy_modal' + this.index);
    },

    //出現面額型折價券
    showDenominationModal() {
      this.handleHide();
      this.$bvModal.show('denomination_modal' + this.index);
    },

    //即享券查詢
    callCheckAccount() {
      discountApi.checkAccount(
        {
          accountNo: this.synEnjoyNum,
          s_no: this.product.BranchRoomID.slice(0, 4)
        },
        res => {
          this.enJoyRes = res;
          this.setCartProductsDiscount({
            index: this.index,
            enJoyRes: res
          });
          let now = moment().format('YYYY/MM/DD');
          let expired = moment(res.expire_date).format('YYYY/MM/DD');
          if (res.accountStatus == 'N' || now > expired) {
            alert('即享券已失效');
            return;
          } else if (res.accountType == '3') {
            discountApi.queryCrmcoup(
              {
                CompanyID: this.product.ClassBranchId.slice(0, 1) + '0',
                BranchId: this.product.BranchRoomID.slice(0, 4),
                ClassAmnt: this.product.price * this.product.quantity,
                OrderCnt: this.product.quantity,
                DiscSku: this.enJoyRes.discSku,
                DiscupType: 30,
                skipSetApiStatus: true
              },
              res => {
                let queryExpired = moment(res.ValidityEndDate)
                  .add(1, 'day')
                  .format('YYYY/MM/DD');
                if (queryExpired > now) {
                  this.setCartProductsDiscount({
                    index: this.index,
                    denomination: {},
                    balanceEnjoy: res
                  });
                  //若折價券有值
                  if (this.ticketNo) {
                    this.ticketNumHasValueEnjoy(this.showBalanceModal);
                  } else {
                    //這邊是折價券無值
                    this.couponDis = '';
                    this.calculateNoPayAndMinus();
                    this.showBalanceModal(); //餘額
                  }
                } else {
                  alert('即享券已失效');
                  return;
                }
              },
              err => {
                alert(err);
              }
            );
          } else if (res.accountType == '1' || res.accountType == '2') {
            discountApi.queryCrmcoup(
              {
                CompanyID: this.product.ClassBranchId.slice(0, 1) + '0',
                BranchId: this.product.BranchRoomID.slice(0, 4),
                ClassAmnt: this.product.price * this.product.quantity,
                OrderCnt: this.product.quantity,
                DiscSku: this.enJoyRes.discSku,
                DiscupType: 30,
                skipSetApiStatus: true
              },
              res => {
                let queryExpired = moment(res.ValidityEndDate)
                  .add(1, 'day')
                  .format('YYYY/MM/DD');
                if (queryExpired > now) {
                  this.setCartProductsDiscount({
                    index: this.index,
                    balanceEnjoy: {},
                    denomination: res
                  });

                  //若折價券有值
                  if (this.ticketNo) {
                    this.ticketNumHasValueEnjoy(this.showDenominationModal);
                  } else {
                    //這邊是折價券無值
                    this.couponDis = '';
                    this.calculateNoPayAndMinus();
                    this.showDenominationModal(); //面額
                  }
                } else {
                  alert('即享券已失效');
                  return;
                }
              },
              err => {
                alert(err);
              }
            );
          } else {
            alert('即享券已失效');
            return;
          }
        },
        err => {
          alert(err);
          this.resetEnjoyNum(this.enjoyNumFromVuex);
          return;
        }
      );
    },

    //輸入折價券號碼
    callqueryCrmcoupByHand(callback, callbackForShowModal = null) {
      discountApi.queryCrmcoup(
        {
          CompanyID: this.product.ClassBranchId.slice(0, 1) + '0',
          BranchId: this.product.BranchRoomID.slice(0, 4),
          ClassAmnt: this.product.price * this.product.quantity,
          OrderCnt: this.product.quantity,
          DiscSku: this.ticketNo,
          DiscupType: 11,
          skipSetApiStatus: true
        },
        res => {
          this.couponDis = res.DiscAmnt;
          this.copu_type = 11;
          this.SkuNo10 = res.Skuno;
          this.ReturnSkuNo10 = res.ReturnSkuno;
          this.DiscType10 = res.DiscType;
          this.Grno10 = res.Grno;
          this.rebateName10 = res.RebateName;
          this.setCartProductsDiscount({
            index: this.index,
            ticketNo: this.ticketNo
          });
          callback(callbackForShowModal);
        },
        err => {
          alert(err);
          this.couponDis = this.couponDisInVuex;
          this.resetTicketNum(this.ticketNoFromVuex);
        }
      );
    },

    //即享券無值的運算
    calculate() {
      //總抵扣金額
      let minusAmount =
        this.parseBonusDis + this.parseEnjoyDis + this.parseCouponDis;

      //總金額
      let totalPrice = this.product.price * this.product.quantity;

      //實付金額
      let payPrice = this.product.price * this.product.quantity - minusAmount;

      if (payPrice < 0) {
        if (totalPrice - this.parseBonusDis < 0) {
          alert('折抵金額大於應付金額無法使用');
          return;
        }

        if (totalPrice - (this.parseBonusDis + this.parseEnjoyDis) < 0) {
          alert('折抵金額大於應付金額無法使用');
          return;
        }

        if (
          totalPrice -
            (this.parseBonusDis + this.parseEnjoyDis + this.parseCouponDis) <
          0
        ) {
          alert('折抵金額大於應付金額無法使用');
          return;
        }
        return;
      }

      if (this.isSwitchOn == true) {
        //資料存進vuex
        this.setCartProductsDiscount({
          index: this.index,
          bonusDis: this.bonusDis,
          bonusDefaultNum: this.synBonusNum,
          couponDis: this.couponDis,
          ticketNo: this.ticketNo,
          enjoyDis: this.enjoyNum,
          enjoyDefaultNum: this.synEnjoyNum,
          minusAmount: minusAmount,
          payPrice: payPrice,
          EventMastId: this.EventMastId,
          EventDetlId: this.EventDetlId,
          DESCRITPION: this.DESCRITPION,
          BonusPoints: this.BonusPoints,
          DiscTypePoint: this.DiscTypePoint,
          DscSku: this.DscSku,
          SkuNoPoint: this.SkuNoPoint,
          SkuNo30: '',
          ReturnSkuNo30: '',
          DiscType30: '',
          Grno30: '',
          rebateName30: '',
          accountType: '',
          copu_type: this.couponDis ? 10 : 0,
          SkuNo10: this.couponDis ? this.couponInfoTemp.Skuno : 0,
          ReturnSkuNo10: this.couponDis ? this.couponInfoTemp.ReturnSkuno : 0,
          DiscType10: this.couponDis ? this.couponInfoTemp.DiscType : 0,
          Grno10: this.couponDis ? this.couponInfoTemp.Grno : 0,
          rebateName10: this.couponDis ? this.couponInfoTemp.RebateName : 0,
          balanceEnjoy: {},
          denomination: {},
          RbonusPoints: this.RbonusPoints
        });
        this.$emit('handleHide');
      } else {
        this.setCartProductsDiscount({
          index: this.index,
          bonusDis: this.bonusDis,
          bonusDefaultNum: this.synBonusNum,
          couponDis: this.couponDis,
          ticketNo: this.ticketNo,
          enjoyDis: this.enjoyNum,
          enjoyDefaultNum: this.synEnjoyNum,
          minusAmount: minusAmount,
          payPrice: payPrice,
          EventMastId: this.EventMastId,
          EventDetlId: this.EventDetlId,
          DESCRITPION: this.DESCRITPION,
          BonusPoints: this.BonusPoints,
          DiscTypePoint: this.DiscTypePoint,
          DscSku: this.DscSku,
          SkuNoPoint: this.SkuNoPoint,
          SkuNo30: '',
          ReturnSkuNo30: '',
          DiscType30: '',
          Grno30: '',
          rebateName30: '',
          accountType: '',
          copu_type: this.couponDis ? 11 : 0,
          SkuNo10: this.couponDis ? this.SkuNo10 : 0,
          ReturnSkuNo10: this.couponDis ? this.ReturnSkuNo10 : 0,
          DiscType10: this.couponDis ? this.DiscType10 : 0,
          Grno10: this.couponDis ? this.Grno10 : 0,
          rebateName10: this.couponDis ? this.rebateName10 : 0,
          RbonusPoints: this.RbonusPoints
        });
        this.$emit('handleHide');
      }
    },

    calculateNoPayAndMinus(callbackForShowModal) {
      //總抵扣金額
      let minusAmount =
        this.parseBonusDis + this.parseEnjoyDis + this.parseCouponDis;

      //總金額
      let totalPrice = this.product.price * this.product.quantity;

      //實付金額
      let payPrice = this.product.price * this.product.quantity - minusAmount;

      if (payPrice < 0) {
        if (totalPrice - this.parseBonusDis < 0) {
          alert('折抵金額大於應付金額無法使用');
          return;
        }

        if (
          totalPrice -
            (this.parseBonusDis + this.parseEnjoyDis + this.parseCouponDis) <
          0
        ) {
          alert('折抵金額大於應付金額無法使用');
          return;
        }
        return;
      }
      //折抵金額大於0才繼續往下,跳出即享券的Modal
      if (typeof callbackForShowModal == 'function') callbackForShowModal();

      //資料存進vuex
      if (this.isSwitchOn == true) {
        this.setCartProductsDiscount({
          index: this.index,
          enjoyDefaultNum: this.synEnjoyNum,
          TempSave: {
            bonusDis: this.bonusDis,
            bonusDefaultNum: this.synBonusNum,
            RbonusPoints: this.RbonusPoints,
            couponDis: this.couponDis,
            ticketNo: this.ticketNo,
            EventMastId: this.EventMastId,
            EventDetlId: this.EventDetlId,
            DESCRITPION: this.DESCRITPION,
            DiscTypePoint: this.DiscTypePoint,
            DscSku: this.DscSku,
            SkuNoPoint: this.SkuNoPoint,
            copu_type: this.couponDis ? 10 : 0,
            SkuNo10: this.couponDis ? this.tempSkuno : 0,
            ReturnSkuNo10: this.couponDis ? this.tempReturnSkuno : 0,
            DiscType10: this.couponDis ? this.tempDiscType : 0,
            Grno10: this.couponDis ? this.tempGrno : 0,
            rebateName10: this.couponDis ? this.tempRebateName : 0
          }
        });
      } else {
        this.setCartProductsDiscount({
          index: this.index,
          enjoyDefaultNum: this.synEnjoyNum,
          TempSave: {
            bonusDis: this.bonusDis,
            bonusDefaultNum: this.synBonusNum,
            RbonusPoints: this.RbonusPoints,
            couponDis: this.couponDis,
            ticketNo: this.ticketNo,
            EventMastId: this.EventMastId,
            EventDetlId: this.EventDetlId,
            DESCRITPION: this.DESCRITPION,
            DiscTypePoint: this.DiscTypePoint,
            DscSku: this.DscSku,
            SkuNoPoint: this.SkuNoPoint,
            copu_type: this.couponDis ? 11 : 0,
            SkuNo10: this.couponDis ? this.SkuNo10 : 0,
            ReturnSkuNo10: this.couponDis ? this.ReturnSkuNo10 : 0,
            DiscType10: this.couponDis ? this.DiscType10 : 0,
            Grno10: this.couponDis ? this.Grno10 : 0,
            rebateName10: this.couponDis ? this.rebateName10 : 0
          }
        });
      }
    },
    thTest() {
      alert('測試');
    },

    submit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          alert('欄位輸入有誤');
        } else {
          //紅利點數有值
          if (this.synBonusNum) {
            this.callQueryRedeemHola(this.callCheckAccount);
          } else {
            //紅利點數沒有值,即享券有值
            this.bonusDefaultNum = '';
            this.bonusDis = '';
            this.EventMastId = '';
            this.EventDetlId = '';
            this.DESCRITPION = '';
            this.DiscTypePoint = '';
            this.DscSku = '';
            this.SkuNoPoint = '';
            if (this.synEnjoyNum) {
              this.callCheckAccount();
            } else {
              //這邊是即享券無值
              //  折價券有值
              if (this.ticketNo) {
                this.ticketNumHasValue();
              } else {
                //這邊是折價券無值
                this.couponDis = '';
                this.calculate();
              }
            }
          }
        }
      });
    }
  }
};
</script>
